import {
  PROFILE_FINISHED_WIDGET_RATING_BUTTON_QA_STATE,
  QA_NAME_PROFILE_FINISHED_WIDGET_RATING_BUTTON,
} from './ProfileFinishedWidgetRating.constants'

export function getRatingButtonQaName(hasRating) {
  const state = hasRating
    ? PROFILE_FINISHED_WIDGET_RATING_BUTTON_QA_STATE.edit
    : PROFILE_FINISHED_WIDGET_RATING_BUTTON_QA_STATE.add

  return `${QA_NAME_PROFILE_FINISHED_WIDGET_RATING_BUTTON}_${state}`
}
